import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

interface Body {
  tenant: string;
  deviceId: string;
  username: string;
  password: string;
}

interface Response {
  accessToken: string;
  refreshToken: string;
  userId: string;
}

export function login(body: Body): Promise<AxiosResponse<Response>> {
  return instance.post('/auth/login', body);
}
